import { useState } from "react";
import { Button, Paper } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

import { columns } from "./grid-columns";
import { RebateCompanyForm } from "./rebateCompany.form";
import { SiTrackPage } from "../../../components/si-track-page";
import { rebateCompanyFormSchema } from "./rebate-company-form.schema";
import { RebateCompany } from "../../../models/masters/rebate-company";
import { GuardedComponent } from "../../../components/guarded-component";
import { UserPermissionName } from "../../../models/user-permission-name";
import { SiTrackGrid } from "../../../components/si-track-grid/si-track-grid";
import { SaveHookFormDialog } from "../../../components/save-hook-form.dialog";
import { rebateCompanyApiKeyStore } from "../../../api/masters/rebate-company-api-key-store";

const styling = {
    paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const RebateCompanyPage = () => {

    const [editItem, setEditItem] = useState<Partial<RebateCompany>>();

    const handleEditRebateCompany = (rebateCompany: RebateCompany) => {
        setEditItem(rebateCompany);
    };

    const handleEditClose = () => {
        setEditItem(undefined);
    };

    const handleCreateRebateCompany = () => {
        setEditItem({});
    };

    return (
        <SiTrackPage
            title="Rebate Companies"
            actionButton={
                <GuardedComponent requiredPermissions={[UserPermissionName.ADD_REBATECOMPANY]}>
                    <Button
                        size="small"
                        variant="contained"
                        disableElevation={true}
                        startIcon={<AddIcon />}
                        onClick={handleCreateRebateCompany}
                    >
                        Add Rebate Company
                    </Button>
                </GuardedComponent>
            }
        >
            <Paper elevation={0} style={styling.paperStyle}>
                <SiTrackGrid
                    fileTitle='rebate_company'
                    dataItemKey="utilRebateCompanyID"
                    columns={columns}
                    queryConfig={rebateCompanyApiKeyStore.getRebateCompanies()}
                    onEdit={handleEditRebateCompany}
                    deleteMutationConfig={(deleteItem) => rebateCompanyApiKeyStore.deleteRebateCompany(deleteItem.utilRebateCompanyID)}
                    actionPermissions={{
                        edit: UserPermissionName.EDIT_REBATECOMPANY,
                        delete: UserPermissionName.DELETE_REBATECOMPANY,
                        export: UserPermissionName.DOWNLOAD_GRID
                    }}
                />
                {editItem && (
                    <SaveHookFormDialog
                        title={editItem.utilRebateCompanyID ? 'UPDATE REBATE COMPANY' : 'CREATE REBATE COMPANY'}
                        config={{
                            saveConfig: editItem.utilRebateCompanyID
                                ? rebateCompanyApiKeyStore.updateRebateCompany()
                                : rebateCompanyApiKeyStore.createRebateCompany(),
                            invalidateRoute: () => rebateCompanyApiKeyStore.getRebateCompanies(),
                        }}
                        data={editItem}
                        yupSchema={rebateCompanyFormSchema}
                        onClose={handleEditClose}
                        size="sm"
                    >
                        <RebateCompanyForm />
                    </SaveHookFormDialog>
                )}
            </Paper>
        </SiTrackPage>
    );
}